































import {Component, Inject} from "vue-property-decorator";
import PhoneAddIcon from "../PhoneAddIcon.vue";
import routenames from "../../modules/vRoutedefs";
import UserRequired from "../UserRequired";

@Component({
    components: {
        "at-phone-add-icon": PhoneAddIcon,
    }
})
export default class CardAdd extends UserRequired {
    get qrInitInfoTo() {
        return {path: routenames.start.card.add.qrinfo.path};
    }
}
